module.exports = __webpack_public_path__ + "static/media/one model .8fbe782a.jpg";